var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"service_agreement"},[_c('NavBar'),_c('Header',{attrs:{"type":"personalCenter"}}),_c('div',{staticClass:"content box p300"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.text)}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }